export default interface BulkImport {
    displayProperty: string;
    valueProperty: string;
    header: string;
    dataType: string;
    validation?: Object;
    invalidTooltip?: string;
    component?: BulkDynamicComponentInstance;
    focusedComponent?: BulkDynamicComponentInstance;
    mounted?: (data?: any[], actualData?: ValueData[]) => Promise<void>;
    mapValues?: <T>(csvData: csvTableData<any>[], actualData?: T[]) => Promise<void>;
    resolveMultiple?: boolean;
    defaultValue: number | string | any | null;
    rowClass?: string;
    thClass?: string;
}

export interface EventFunc {
    [key: string]: (arg: BulkCallbackResult<any, any, any>) => Promise<BulkImportOption<[any | any[], any | any[]]>>;
}

export interface BulkDynamicComponentInstance {
    component: any, // Find type for a vue component
    props: Object;
    computed?: Object;
    events: EventFunc;
    hasVModel: boolean;
    class?: string;
}

export interface LoadedFocusedComponent extends BulkDynamicComponentInstance  {
    property: string;
    index: number;
    id: number;
}

export interface csvHeader {
    property: string;
    header: string;
}

export interface BulkCallbackResult<BulkTypeRow, EventData, VM> {
    currentRow: BulkTypeRow;
    eventData: EventData;
    vm: VM;
}

export interface ValueData {
    valueProperty?: string;
    displayProperty: string;
    index: number;
    value: any;
    id: number;
}

export interface BulkType<T, R> {
    title: string
    bulkImportType: BulkImportType;
    bulkImportCsvTemplate: () => void;
    rawDataTemplate: T;
    bulkTemplate: R;
}

export interface ImportBulkType<T, R> {
    bulkType: BulkType<R, T>;
    metaData: BulkImport[];
    mapValues: (csvData: csvTableData<T>[], rawData: R[]) => void;
}

export enum BulkImportType {
    AlarmActions = 1,
    Contacts = 2,
}

export type csvTableData<T> = T & {
    id: number;
};

export enum BulkImportDataTypes {
    Boolean = "boolean",
    Text = "text",
    Number = "number",
}

export enum ValidationStatus {
    Submittable = 1,
    NotSubmittable = 2,
    ValidatedByServer = 3,
    ServerValidationError = 4,
    ClientValidationError = 5,
}

export enum BulkImportOptionStatus {
    Error,
    Continue,
    Singular
}

export interface BulkImportOption<T> {
    status: BulkImportOptionStatus,
    data: T
}

export interface IBulkImportTable {
    updateProp: (currentProp: string, targetProp: string) => void;
}

export interface SearchResult<T> {
    data: T,
    loading: (loading: boolean) => void
}